<!-- Local SVG -->
<ng-container *ngIf="!isExternal">
  <svg-icon [src]="assetPath + svgUrl"></svg-icon>
</ng-container>

<!-- External URL with loading state -->
<ng-container *ngIf="isExternal">
  <div class="logo-skeleton" *ngIf="isLoading"></div>
  <img
    [src]="externalUrl"
    alt="Logo"
    class="external-logo"
    (load)="onImageLoad()"
    (error)="onImageError()"
    [style.display]="isLoading ? 'none' : 'block'"
  />
</ng-container>
